module.exports = __webpack_public_path__ + "9779d9a1/img/settings-ico.a214628d.svg";